import PageDTO from "@/api/commons/PageDTO";

export default class FiltroServicoDTO {
  statusSolicitacao?: string[];
  dataInicial?: string;
  dataFinal?: string;
  pagination: PageDTO;
  tipoServico?: string;
  numeroServico?: string;
  statusServico?: string[];
  constructor(
    pagination: PageDTO,
    statusSolicitacao?: string[],
    dataInicial?: string,
    dataFinal?: string,
    tipoServico?: string,
    numeroServico?: string,
    statusServico?: string[]
  ) {
    this.statusSolicitacao = statusSolicitacao;
    this.dataInicial = dataInicial;
    this.dataFinal = dataFinal;
    this.pagination = pagination;
    this.tipoServico = tipoServico;
    this.numeroServico = numeroServico;
    this.statusServico = statusServico;
  }
}
